import React from 'react'

export function FullWindowOverlay({ children }: { children: React.ReactNode }): React.ReactNode {
  return <>{children}</>
}
